export class RecuperarSenhaRetornoFormModel {
    constructor(
        public codigo: string = ''
    ) { }
}